export const daemonsInitialState = {
  daemons: {
    data: [],
    meta: {
      isLoading: false,
      hasError: false,
      loaded: false,
      syncStatus: {
        current: null,
        next: null
      }
    }
  }
};
